export function commentableToString({
  created_at,
  author,
  content,
  ...val
}: ICommentable) {
  const date = new Date(created_at || "").toLocaleDateString('en-US').replace(/\//g, '-');
  const dateString = val.showObservationDatesOfFindings ? `${date} -` : '';
  if(val.is_completed_by_guest && val.completed_by){
    const name = val.completed_by
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
    return ` ${dateString} ${name} : ${content}`
  }
  return ` ${dateString} ${author.name} : ${content}`;
}

export interface ICommentable {
  id: number;
  created_at?: string;
  createdAt?: string;
  content: string;
  observation_type?: string;
  author: {
    name: string;
    id: number;
  };
  /** Inspection notes carry their text here; finding observations use `content`. */
  note?: {
    content: string;
  };
  commentable_id?: number;
  userId?: number;
  is_completed_by_guest?: boolean;
  completed_by?: string;
  showObservationDatesOfFindings?: boolean;
}

/**
 * SW2-2472 — a commentable's text. Inspection notes come from `/api/notes/inspections` (and the
 * offline copy) as `{ note: { content } }`; finding observations as a flat `content`. Reading only
 * `content` showed every inspection note as just its author's name.
 */
export const commentableContent = (item: Pick<ICommentable, 'content' | 'note'>): string =>
  (item.note ? item.note.content : item.content) || '';
